import { ActionType } from "../constants/general";

import { getTagsApi } from "../../api/general/general";

export const getTagsAction = () => dispatch => {
  return getTagsApi()
    .then(
      dispatch({
        type: ActionType.GET_TAGS_ARRAY_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.GET_TAGS_ARRAY_SUCCESS,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: ActionType.GET_TAGS_ARRAY_ERROR,
        payload: error.response
      });
    });
};
